import ConformationModal from "./ConfirmationModal";

export default ConformationModal;
